import { toString as toString_1, Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { int32_type, obj_type, union_type, record_type, string_type, option_type, array_type, class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Dashboard_AccountTicketEntry_$reflection, Dashboard_CustomerTicketEntry_$reflection, Dashboard_CompanyTicketEntry_$reflection, CustomerGroup_$reflection } from "../Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { fromDateTime } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { now, addMonths } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { orElse, unwrap, map, defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toRequestPath } from "./DashboardCriticalOperationalHalts.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, equals, comparePrimitives, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Table, TablePagination, TableFooter, TableBody, TableHead, TableRow, Skeleton, Typography, TableSortLabel, TableCell, MenuItem, TextField } from "@mui/material";
import { getSubArray, sortBy, map as map_1, tryFind } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { Account_tryGetNameStr, sortFn } from "../Utils.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { createDisposable } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { SnackError, onPageChange } from "../ViewHelpers.js";
import { strIContains } from "../Shared/Shared.js";
import { Components_UserSearchBar_25368B8A } from "../Components/UserSearchBar.js";
import { CustomerGroup_fetchGroups } from "../Promises.js";

class Model extends Record {
    constructor(PeriodStart, PeriodEnd, CustomerGroups, SelectedGroup, ErrorMsg) {
        super();
        this.PeriodStart = PeriodStart;
        this.PeriodEnd = PeriodEnd;
        this.CustomerGroups = CustomerGroups;
        this.SelectedGroup = SelectedGroup;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.Dashboards.Tickets.Model", [], Model, () => [["PeriodStart", class_type("System.DateOnly")], ["PeriodEnd", class_type("System.DateOnly")], ["CustomerGroups", array_type(CustomerGroup_$reflection())], ["SelectedGroup", option_type(CustomerGroup_$reflection())], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GroupsResponse", "UpdatePeriodStart", "UpdatePeriodEnd", "SelectGroup", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.Dashboards.Tickets.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(CustomerGroup_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(CustomerGroup_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", class_type("System.DateOnly")]], [["Item", class_type("System.DateOnly")]], [["Item", option_type(CustomerGroup_$reflection())]], []]);
}

function init() {
    return new Model(fromDateTime(addMonths(now(), -1)), fromDateTime(now()), [], undefined, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(msg.fields[0], model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.ErrorMsg);
        case 2:
            return new Model(model.PeriodStart, msg.fields[0], model.CustomerGroups, model.SelectedGroup, model.ErrorMsg);
        case 3:
            return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, msg.fields[0], model.ErrorMsg);
        case 4:
            return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                console.error(some("[AdminDashboardTickets] Error fetching groups!"), res.fields[0]);
                return model;
            }
            else {
                return new Model(model.PeriodStart, model.PeriodEnd, res.fields[0], model.SelectedGroup, model.ErrorMsg);
            }
        }
    }
}

function fetchCompanyStats(periodStart, periodEnd, group) {
    let properties_2;
    const requestPath = toRequestPath(periodStart, periodEnd, group, "/api/dashboard/tickets/company-status");
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_CompanyTicketEntry_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_CompanyTicketEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function fetchCustomerStats(periodStart, periodEnd, group) {
    let properties_2;
    const url = toRequestPath(periodStart, periodEnd, group, "/api/dashboard/tickets/customer-status");
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_CustomerTicketEntry_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_CustomerTicketEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function fetchResponsibleStats(periodStart, periodEnd, group) {
    let properties_2;
    const url = toRequestPath(periodStart, periodEnd, group, "/api/dashboard/tickets/responsible-status");
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_AccountTicketEntry_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_AccountTicketEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function tryGetNameStr(entry) {
    if (!isNullOrWhiteSpace(entry.Firstname) && !isNullOrWhiteSpace(entry.Lastname)) {
        return `${entry.Firstname} ${entry.Lastname}`;
    }
    else {
        return entry.Email;
    }
}

function drawFilter(locale, model, dispatch) {
    let elems;
    const ctx = reactApi.useContext(ctx_1);
    return MuiHelpers_createElement(TextField, [["sx", {
        flexBasis: 320,
    }], ["select", true], ["size", "small"], ["label", ctx.Locale.t("VismaSync.ChooseGroup")], ["value", orElse(map((c) => c.Id, model.SelectedGroup), -1)], ["onChange", (ev) => {
        const gId = ev.target.value | 0;
        dispatch(new Message(3, [tryFind((cg) => (cg.Id === gId), model.CustomerGroups)]));
    }], (elems = [MuiHelpers_createElement(MenuItem, [["value", -1], ["children", locale.t("All")]]), map_1((customer) => MuiHelpers_createElement(MenuItem, [["value", customer.Id], ["children", customer.Name]]), sortBy((c_1) => c_1.Name.toLocaleLowerCase(), model.CustomerGroups, {
        Compare: comparePrimitives,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

function th$0027(asc, sortKey, onClick, key, txt) {
    return MuiHelpers_createElement(TableCell, toList(delay(() => append(asc ? singleton(["sortDirection", "asc"]) : singleton(["sortDirection", "desc"]), delay(() => append(singleton(["variant", "head"]), delay(() => singleton(["children", MuiHelpers_createElement(TableSortLabel, toList(delay(() => append(singleton(["onClick", (_arg) => {
        onClick(key);
    }]), delay(() => append(asc ? singleton(["direction", "asc"]) : singleton(["direction", "desc"]), delay(() => append(singleton(["active", equals(key, sortKey)]), delay(() => singleton(["children", MuiHelpers_createElement(Typography, [["children", txt]])]))))))))))]))))))));
}

function cell(title, child) {
    return MuiHelpers_createElement(TableCell, toList(delay(() => {
        let matchValue;
        return append((matchValue = title, (matchValue != null) ? singleton(["title", matchValue]) : (empty_1())), delay(() => append(singleton(["variant", "body"]), delay(() => singleton(["children", child])))));
    })));
}

function textCell(text) {
    return cell(undefined, toString_1(text));
}

function longCell(width, text) {
    const child = MuiHelpers_createElement(Typography, [["noWrap", true], ["variant", "body2"], ["children", text]]);
    return MuiHelpers_createElement(TableCell, [["title", text], ["sx", {
        minWidth: width,
        maxWidth: width,
    }], ["variant", "body"], ["children", child]]);
}

class UserEntry extends Record {
    constructor(User, NumOpen, NumClosed, NumCritical, NumMonthOld, NumYearOld) {
        super();
        this.User = User;
        this.NumOpen = (NumOpen | 0);
        this.NumClosed = (NumClosed | 0);
        this.NumCritical = (NumCritical | 0);
        this.NumMonthOld = (NumMonthOld | 0);
        this.NumYearOld = (NumYearOld | 0);
    }
}

function UserEntry_$reflection() {
    return record_type("Kundeweb.Dashboards.Tickets.UserEntry", [], UserEntry, () => [["User", string_type], ["NumOpen", int32_type], ["NumClosed", int32_type], ["NumCritical", int32_type], ["NumMonthOld", int32_type], ["NumYearOld", int32_type]]);
}

class StatsListEntry extends Record {
    constructor(Customer, NumClosed, NumOpen, NumCritical) {
        super();
        this.Customer = Customer;
        this.NumClosed = (NumClosed | 0);
        this.NumOpen = (NumOpen | 0);
        this.NumCritical = (NumCritical | 0);
    }
}

function StatsListEntry_$reflection() {
    return record_type("Kundeweb.Dashboards.Tickets.StatsListEntry", [], StatsListEntry, () => [["Customer", string_type], ["NumClosed", int32_type], ["NumOpen", int32_type], ["NumCritical", int32_type]]);
}

function TicketsByCustomer(ticketsByCustomerInputProps) {
    let elems_7;
    const group = ticketsByCustomerInputProps.group;
    const periodEnd = ticketsByCustomerInputProps.periodEnd;
    const periodStart = ticketsByCustomerInputProps.periodStart;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(true);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState([]);
    const entries = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const asc = patternInput_2[0];
    const patternInput_3 = reactApi.useState("NumOpen");
    const sortKey = patternInput_3[0];
    const patternInput_4 = reactApi.useState(0);
    const setPage = patternInput_4[1];
    const page = patternInput_4[0] | 0;
    const patternInput_5 = reactApi.useState(5);
    const rowsPerPage = patternInput_5[0] | 0;
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((entries.length < nextTakeCount) ? (entries.length - rowsToSkip) : rowsPerPage);
    const currentRows = getSubArray(sortFn(asc, sortKey)(entries), rowsToSkip, rowsToTake);
    useEffectWithDeps(() => {
        let active = true;
        setLoading(true);
        const pr = fetchCustomerStats(periodStart, periodEnd, group);
        pr.then((res) => {
            setLoading(false);
            if (active) {
                if (res.tag === 0) {
                    patternInput_1[1](res.fields[0]);
                }
                else {
                    console.error(some("[DashboardTickets] Error fetching ticket stats per customer"), res.fields[0]);
                }
            }
            else {
                console.debug("[DashboardTickets] Fetched customers while active");
            }
        });
        return createDisposable(() => {
            active = false;
        });
    }, [periodStart, periodEnd, group]);
    const header = (key, txt) => th$0027(asc, sortKey, (newKey) => {
        patternInput_3[1](newKey);
        patternInput_2[1]((newKey === sortKey) ? !asc : true);
    }, key, txt);
    return createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 20 + "px ",
    }], (elems_7 = toList(delay(() => append(singleton(MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", ctx.Locale.t("Dashboard.Tickets.ByCustomer")]])), delay(() => {
        let children_5, children_1, children, children_3, elements_5, children_4, values;
        return patternInput[0] ? singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
            minWidth: 200,
            minHeight: 200,
        }]])) : singleton((children_5 = ofArray([(children_1 = singleton_1((children = ofArray([header("Customer", ctx.Locale.t("Customer.Customer")), header("NumOpen", ctx.Locale.t("Dashboard.Tickets.Open")), header("NumClosed", ctx.Locale.t("Dashboard.Tickets.Closed")), header("NumCritical", ctx.Locale.t("Dashboard.Tickets.Critical"))]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_3 = map_1((entry) => {
            const children_2 = ofArray([longCell(30 + "ch", entry.Customer), textCell(entry.NumOpen), textCell(entry.NumClosed), textCell(entry.NumCritical)]);
            return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_2))]]);
        }, currentRows), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_3))]])), MuiHelpers_createElement(TableFooter, [(elements_5 = [(children_4 = singleton_1(MuiHelpers_createElement(TablePagination, [["count", entries.length], ["page", page], ["rowsPerPage", rowsPerPage], (values = (new Int32Array([5, 10, 15])), ["rowsPerPageOptions", Array.from(values)]), ["onPageChange", ((arg10$0040, newPage) => {
            onPageChange(setPage, arg10$0040, newPage);
        })], ["onRowsPerPageChange", (ev) => {
            const newRowsPerPage = ev.target.value | 0;
            setPage(0);
            patternInput_5[1](newRowsPerPage);
        }]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_4))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])])]), MuiHelpers_createElement(Table, [["children", reactApi.Children.toArray(Array.from(children_5))]])));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

function TicketsByResponsible(ticketsByResponsibleInputProps) {
    let elems_7;
    const group = ticketsByResponsibleInputProps.group;
    const periodEnd = ticketsByResponsibleInputProps.periodEnd;
    const periodStart = ticketsByResponsibleInputProps.periodStart;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(true);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState([]);
    const entries = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const asc = patternInput_2[0];
    const patternInput_3 = reactApi.useState("NumOpen");
    const sortKey = patternInput_3[0];
    const patternInput_4 = reactApi.useState(0);
    const setPage = patternInput_4[1];
    const page = patternInput_4[0] | 0;
    const patternInput_5 = reactApi.useState(5);
    const rowsPerPage = patternInput_5[0] | 0;
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((entries.length < nextTakeCount) ? (entries.length - rowsToSkip) : rowsPerPage);
    const currentRows = getSubArray(sortFn(asc, sortKey)(entries), rowsToSkip, rowsToTake);
    useEffectWithDeps(() => {
        let active = true;
        setLoading(true);
        const pr = fetchResponsibleStats(periodStart, periodEnd, group);
        pr.then((res) => {
            setLoading(false);
            if (active) {
                if (res.tag === 0) {
                    patternInput_1[1](map_1((entry) => (new StatsListEntry(tryGetNameStr(entry), entry.NumClosed, entry.NumOpen, entry.NumCritical)), res.fields[0]));
                }
                else {
                    console.error(some("[DashboardTickets] Error fetching ticket responsible stats"), res.fields[0]);
                }
            }
            else {
                console.debug("[DashboardTickets] Fetched ticket responsible stats while active");
            }
        });
        return createDisposable(() => {
            active = false;
        });
    }, [periodStart, periodEnd, group]);
    const header = (key, txt) => th$0027(asc, sortKey, (newKey) => {
        patternInput_3[1](newKey);
        patternInput_2[1]((newKey === sortKey) ? !asc : true);
    }, key, txt);
    return createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 20 + "px ",
    }], (elems_7 = toList(delay(() => append(singleton(MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", ctx.Locale.t("Dashboard.Tickets.ByResponsible")]])), delay(() => {
        let children_5, children_1, children, children_3, elements_5, children_4, values;
        return patternInput[0] ? singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
            minWidth: 200,
            minHeight: 200,
        }]])) : singleton((children_5 = ofArray([(children_1 = singleton_1((children = ofArray([header("Customer", ctx.Locale.t("Ticket.Responsible")), header("NumOpen", ctx.Locale.t("Dashboard.Tickets.Open")), header("NumClosed", ctx.Locale.t("Dashboard.Tickets.Closed")), header("NumCritical", ctx.Locale.t("Dashboard.Tickets.Critical"))]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_3 = map_1((entry_1) => {
            const children_2 = ofArray([longCell(30 + "ch", entry_1.Customer), textCell(entry_1.NumOpen), textCell(entry_1.NumClosed), textCell(entry_1.NumCritical)]);
            return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_2))]]);
        }, currentRows), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_3))]])), MuiHelpers_createElement(TableFooter, [(elements_5 = [(children_4 = singleton_1(MuiHelpers_createElement(TablePagination, [["count", entries.length], ["page", page], ["rowsPerPage", rowsPerPage], (values = (new Int32Array([5, 10, 15])), ["rowsPerPageOptions", Array.from(values)]), ["onPageChange", ((arg10$0040, newPage) => {
            onPageChange(setPage, arg10$0040, newPage);
        })], ["onRowsPerPageChange", (ev) => {
            const newRowsPerPage = ev.target.value | 0;
            setPage(0);
            patternInput_5[1](newRowsPerPage);
        }]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_4))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])])]), MuiHelpers_createElement(Table, [["children", reactApi.Children.toArray(Array.from(children_5))]])));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

function UserTable() {
    let elems, elems_8, elements_6, elements_1, elements, elements_3, elements_5, children, values;
    const patternInput = reactApi.useState(undefined);
    const selected = patternInput[0];
    const patternInput_1 = reactApi.useState([]);
    const entries = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const asc = patternInput_2[0];
    const patternInput_3 = reactApi.useState("NumOpen");
    const sortKey = patternInput_3[0];
    const patternInput_4 = reactApi.useState(0);
    const setPage = patternInput_4[1];
    const page = patternInput_4[0] | 0;
    const patternInput_5 = reactApi.useState(5);
    const rowsPerPage = patternInput_5[0] | 0;
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((entries.length < nextTakeCount) ? (entries.length - rowsToSkip) : rowsPerPage);
    const currentRows = getSubArray(sortFn(asc, sortKey)(entries.filter((entry) => {
        if (selected == null) {
            return true;
        }
        else {
            return defaultArg(map((s) => strIContains(entry.User, Account_tryGetNameStr(s)), selected), false);
        }
    })), rowsToSkip, rowsToTake);
    useEffectWithDeps(() => {
        let properties_2;
        let active = true;
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_AccountTicketEntry_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/dashboard/tickets/responsible-status", properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_AccountTicketEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (!active) {
                console.debug("[AdminDashboardTickets] Started new user ticket fetch while not active");
            }
            else if (res.tag === 0) {
                patternInput_1[1](map_1((entry_1) => (new UserEntry(tryGetNameStr(entry_1), entry_1.NumOpen, entry_1.NumClosed, entry_1.NumCritical, entry_1.NumMonthOld, 0)), res.fields[0]));
            }
            else {
                console.error(some("[AdminDashboardTickets] Error fetching user ticket stats"), res.fields[0]);
            }
        });
        return createDisposable(() => {
            active = false;
        });
    }, []);
    const header = (key_1, txt) => th$0027(asc, sortKey, (key) => {
        patternInput_3[1](key);
        patternInput_2[1]((key !== sortKey) ? true : !asc);
    }, key_1, txt);
    const xs_3 = [createElement("div", createObj(ofArray([["style", {
        maxWidth: 250 + "px",
    }], (elems = [createElement(Components_UserSearchBar_25368B8A, {
        onSelect: (arg_1) => {
            patternInput[1](arg_1);
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], (elems_8 = [MuiHelpers_createElement(Table, [(elements_6 = [MuiHelpers_createElement(TableHead, [(elements_1 = [MuiHelpers_createElement(TableRow, [(elements = [header("User", "Bruker"), header("NumOpen", "Åpne"), header("NumClosed", "Lukkede"), header("NumCritical", "Kritiske"), header("NumMonthOld", "Over 1 måned gammel"), header("NumYearOld", "Over 1 år gammel")], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(TableBody, [(elements_3 = map_1((entry_2) => {
        let elements_2;
        return MuiHelpers_createElement(TableRow, [(elements_2 = [longCell(30 + "ch", entry_2.User), textCell(entry_2.NumOpen), textCell(entry_2.NumClosed), textCell(entry_2.NumCritical), textCell(entry_2.NumMonthOld), textCell(entry_2.NumYearOld)], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    }, currentRows), ["children", reactApi.Children.toArray(Array.from(elements_3))])]), MuiHelpers_createElement(TableFooter, [(elements_5 = [(children = singleton_1(MuiHelpers_createElement(TablePagination, [["count", entries.length], ["page", page], ["rowsPerPage", rowsPerPage], (values = (new Int32Array([5, 10, 15])), ["rowsPerPageOptions", Array.from(values)]), ["onPageChange", ((arg10$0040, newPage) => {
        onPageChange(setPage, arg10$0040, newPage);
    })], ["onRowsPerPageChange", (ev) => {
        const newRowsPerPage = ev.target.value | 0;
        setPage(0);
        patternInput_5[1](newRowsPerPage);
    }]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])])], ["children", reactApi.Children.toArray(Array.from(elements_6))])])], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))];
    return react.createElement(react.Fragment, {}, ...xs_3);
}

function CompaniesTable(companiesTableInputProps) {
    let children_1, children, children_3, elements_5, children_4, values;
    const group = companiesTableInputProps.group;
    const periodEnd = companiesTableInputProps.periodEnd;
    const periodStart = companiesTableInputProps.periodStart;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const loading = patternInput[0];
    const patternInput_1 = reactApi.useState([]);
    const entries = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const asc = patternInput_2[0];
    const patternInput_3 = reactApi.useState("NumOpen");
    const sortKey = patternInput_3[0];
    const patternInput_4 = reactApi.useState(0);
    const setPage = patternInput_4[1];
    const page = patternInput_4[0] | 0;
    const patternInput_5 = reactApi.useState(5);
    const rowsPerPage = patternInput_5[0] | 0;
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((entries.length < nextTakeCount) ? (entries.length - rowsToSkip) : rowsPerPage);
    const currentRows = getSubArray(sortFn(asc, sortKey)(entries), rowsToSkip, rowsToTake);
    useEffectWithDeps(() => {
        let active = true;
        if (!loading) {
            setLoading(true);
            const pr = fetchCompanyStats(periodStart, periodEnd, group);
            pr.then((res) => {
                setLoading(false);
                if (!active) {
                    console.debug("[AdminDashboardTickets] Started new company stats while not active");
                }
                else if (res.tag === 0) {
                    patternInput_1[1](res.fields[0]);
                }
                else {
                    console.error(some("[AdminDashboardTickets] Error fetching company stats"), res.fields[0]);
                }
            });
        }
        return createDisposable(() => {
            active = false;
        });
    }, [periodStart, periodEnd, group]);
    const header = (key_1, txt) => th$0027(asc, sortKey, (key) => {
        patternInput_3[1](key);
        patternInput_2[1]((key !== sortKey) ? true : !asc);
    }, key_1, txt);
    if (loading) {
        return MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
            minWidth: 200,
            minHeight: 200,
        }]]);
    }
    else {
        const children_5 = ofArray([(children_1 = singleton_1((children = ofArray([header("Company", ctx.Locale.t("Company")), header("NumOpen", ctx.Locale.t("Dashboard.Tickets.Open")), header("NumClosed", ctx.Locale.t("Dashboard.Tickets.Closed")), header("NumCritical", ctx.Locale.t("Dashboard.Tickets.Critical")), header("NumDurationWeek", ctx.Locale.t("Dashboard.Tickets.OlderThanWeek")), header("NumDurationMonth", ctx.Locale.t("Dashboard.Tickets.OlderThanMonth")), header("NumDurationYear", ctx.Locale.t("Dashboard.Tickets.OlderThanYear"))]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_3 = map_1((entry) => {
            const children_2 = ofArray([longCell(20 + "ch", entry.Company), textCell(entry.NumOpen), textCell(entry.NumClosed), textCell(entry.NumCritical), textCell(entry.NumDurationWeek), textCell(entry.NumDurationMonth), textCell(entry.NumDurationYear)]);
            return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_2))]]);
        }, currentRows), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_3))]])), MuiHelpers_createElement(TableFooter, [(elements_5 = [(children_4 = singleton_1(MuiHelpers_createElement(TablePagination, [["count", entries.length], ["page", page], ["rowsPerPage", rowsPerPage], (values = (new Int32Array([5, 10, 15])), ["rowsPerPageOptions", Array.from(values)]), ["onPageChange", ((arg10$0040, newPage) => {
            onPageChange(setPage, arg10$0040, newPage);
        })], ["onRowsPerPageChange", (ev) => {
            const newRowsPerPage = ev.target.value | 0;
            setPage(0);
            patternInput_5[1](newRowsPerPage);
        }]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_4))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])])]);
        return MuiHelpers_createElement(Table, [["children", reactApi.Children.toArray(Array.from(children_5))]]);
    }
}

export function View() {
    let elems_3, elems, elems_2, elems_1, elems_4, elems_6, elems_5;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    reactApi.useEffect(() => {
        const pr = CustomerGroup_fetchGroups(false);
        pr.then((arg_2) => {
            dispatch(new Message(0, [arg_2]));
        });
    }, []);
    const xs_7 = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(4, []));
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px",
    }], (elems_3 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("Dashboard.PerCustomer")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 15 + "px ",
    }], (elems = [drawFilter(ctx.Locale, model_1, dispatch)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {}], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: 20 + "px ",
    }], (elems_1 = [createElement(TicketsByCustomer, {
        periodStart: model_1.PeriodStart,
        periodEnd: model_1.PeriodEnd,
        group: unwrap(model_1.SelectedGroup),
    }), createElement(TicketsByResponsible, {
        periodStart: model_1.PeriodStart,
        periodEnd: model_1.PeriodEnd,
        group: unwrap(model_1.SelectedGroup),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px",
    }], (elems_4 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("Dashboard.PerUser")]]), createElement(UserTable, null)], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px",
    }], (elems_6 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("Dashboard.PerDepartment")]]), createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], (elems_5 = [createElement(CompaniesTable, {
        periodStart: model_1.PeriodStart,
        periodEnd: model_1.PeriodEnd,
        group: unwrap(model_1.SelectedGroup),
    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))];
    return react.createElement(react.Fragment, {}, ...xs_7);
}

